import request from './index';

export function addCase(data) {
  return request.post('officialPageCase/add', data);
}

export function updateCase(data) {
  return request.post('officialPageCase/update', data);
}

export function deleteCase(id) {
  return request.post('officialPageCase/delete', { id });
}

export function getCaseDetail(id) {
  return request.get('officialPageCase/detail', { params: { id } });
}

export function getCasePage(params) {
  return request.get('officialPageCase/page', { params });
}

export function getCaseList(params) {
  return request.get('officialPageCase/list', { params });
}
